<div class="messages" data-testid="messages-container">
  <div class="messages__header">
    <span class="messages__contact-name">{{ headerTitle() }}</span>
    <span class="messages__vendor-name">{{ headerSubtitle() }}&nbsp;</span>
  </div>

  <div class="messages__chat-area" #chatArea data-testid="messages-history">
    @if (hasOlderMessages()) {
      <button class="messages__load-more" type="button" data-testid="messages-load-older" (click)="loadPreviousMessages()">
        Click to load previous messages
      </button>
    }
    <div class="messages__chat-content">
    @for (group of groupedMessages(); track group.date) {
      <div class="messages__date-separator">
        <span class="messages__date-label">{{ group.date }}</span>
      </div>

      @for (msg of group.messages; track msg.originalIndex) {
        @if (msg.originalIndex === firstAdminOriginalIndex()) {
          <div class="messages__admin-banner">
            <span>AZ Translate Administrator joined the conversation and can view all chat history</span>
          </div>
        }
        <div
          class="messages__bubble-row"
          [class.messages__bubble-row--received]="!isOwnMessage(msg)"
          [class.messages__bubble-row--sent]="isOwnMessage(msg)"
          [class.messages__bubble-row--consecutive]="isConsecutiveWithPrevious(group.messages, $index)"
        >
          <div class="messages__bubble-wrapper">
            <div
              class="messages__bubble"
              [class.messages__bubble--received]="!isOwnMessage(msg)"
              [class.messages__bubble--sent]="isOwnMessage(msg)"
              [class.messages__bubble--last-received]="!isOwnMessage(msg) && !hasNextConsecutive(group.messages, $index)"
              [class.messages__bubble--last-sent]="isOwnMessage(msg) && !hasNextConsecutive(group.messages, $index)"
            >
              @if (shouldShowSender(group.messages, $index)) {
                <span
                  class="messages__sender"
                  [class.messages__sender--received]="!isOwnMessage(msg)"
                  [class.messages__sender--sent]="isOwnMessage(msg)"
                >
                  @if (isAdminMessage(msg)) {
                    AZ Translate Administrator
                    <span class="messages__sender-detail">({{ formatAdminName(msg.author) }})</span>
                  } @else {
                    {{ formatAuthor(msg.author) }}
                  }
                </span>
              }
              @if (msg.attachments.length) {
                <div class="messages__attachments">
                  @for (
                    attachment of msg.attachments;
                    track attachment.fileName
                  ) {
                    <button
                      class="messages__attachment-link"
                      [class.messages__attachment-link--sent]="
                        isOwnMessage(msg)
                      "
                      (click)="downloadAttachment(attachment, msg.originalIndex)"
                      type="button"
                    >
                      <mat-icon [svgIcon]="isOwnMessage(msg) ? 'file_attachment_white' : 'file_attachment'"></mat-icon>
                      <span class="messages__attachment-name">
                        <span class="messages__attachment-name-base">{{ getFileBaseName(attachment.fileName) }}</span><span class="messages__attachment-name-ext">{{ getFileExtension(attachment.fileName) }}</span>
                      </span>
                    </button>
                  }
                </div>
              }
              <div class="messages__content-row">
                @if (msg.message) {
                  <span
                    class="messages__text"
                    [class.messages__text--clamped]="isTextClamped(msg)"
                    [style.-webkit-line-clamp]="isTextClamped(msg) ? getMaxLines(msg.originalIndex) : null"
                    [attr.data-msg-index]="msg.originalIndex"
                  >{{ msg.message }}</span>
                }
                @if (needsReadMore(msg)) {
                  <button
                    class="messages__expand-btn"
                    [class.messages__expand-btn--sent]="isOwnMessage(msg)"
                    type="button"
                    (click)="showMore(msg.originalIndex)"
                  >Read more...</button>
                } @else if (isExpanded(msg.originalIndex)) {
                  <button
                    class="messages__expand-btn"
                    [class.messages__expand-btn--sent]="isOwnMessage(msg)"
                    type="button"
                    (click)="collapse(msg.originalIndex)"
                  >Collapse</button>
                }
                <span class="messages__time">{{
                  msg.timestamp | date: "h:mm a"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    }
    </div>

    @if (!groupedMessages().length) {
      <div class="messages__empty">
        <p>{{ readOnly() ? 'No messages were sent.' : 'No messages yet.' }}</p>
      </div>
    }
  </div>

  @if (!readOnly()) {
    <div class="messages__compose" data-testid="messages-compose">
      @if (stagedAttachments().length) {
        <div class="messages__staged-files">
          @for (
            attachment of stagedAttachments();
            track attachment.name;
            let i = $index
          ) {
            <div class="messages__staged-chip">
              <mat-icon class="messages__staged-icon" svgIcon="file_attachment" aria-hidden="true"></mat-icon>
              <div class="messages__staged-info">
                <span class="messages__staged-name">
                  <span class="messages__staged-name-base">{{ getFileBaseName(attachment.name) }}</span><span class="messages__staged-name-ext">{{ getFileExtension(attachment.name) }}</span>
                </span>
                <span class="messages__staged-size">{{ formatFileSize(attachment.file.size) }}</span>
              </div>
              <button
                class="messages__staged-remove"
                type="button"
                (click)="removeAttachment(i)"
                [attr.aria-label]="'Remove ' + attachment.name"
              >
                &times;
              </button>
            </div>
          }
        </div>
      }

      <div class="messages__input-bar">
        <input
          #fileInput
          type="file"
          class="messages__file-input"
          [accept]="allowedAccept"
          multiple
          (change)="onFilesSelected($event)"
          aria-hidden="true"
          tabindex="-1"
        />
        <button
          class="messages__attach-btn"
          type="button"
          aria-label="Attach file"
          data-testid="messages-attach"
          (click)="onAttachClick()"
        >
          <mat-icon>attach_file</mat-icon>
        </button>
        <textarea
          #messageInput
          class="messages__input"
          data-testid="messages-input"
          placeholder="Message..."
          [value]="newMessage()"
          [maxLength]="charLimit"
          (input)="onInputChange($event)"
          (keydown)="onKeydown($event)"
          aria-label="Type a message"
          rows="1"
        ></textarea>
        <button
          class="messages__send-btn"
          type="button"
          aria-label="Send message"
          data-testid="messages-send"
          [disabled]="!canSend() || sending()"
          (click)="onSend()"
        >
          <mat-icon>send</mat-icon>
        </button>
      </div>

      <div
        class="messages__char-counter"
        [class.messages__char-counter--limit]="isCharLimitReached()"
      >
        @if (isCharLimitReached()) {
          <span>Character limit reached</span>
        } @else {
          <span>{{ charCount() }} / {{ charLimit }}</span>
        }
      </div>
    </div>
  } @else {
    <div class="messages__readonly-bar" data-testid="messages-readonly-banner">
      <span>This conversation is read-only.</span>
    </div>
  }
</div>
